import { AIChatbotAssistantType, AIChatbotEvents, trackAIChatbotEvent } from './ai-chatbot-events';

interface StarterImpression {
    id: number;
    question: string;
    type: string;
}

// Plain function (not a React hook) so Lit components can call it too.
// `position` is the caller's rendering index — the API doesn't carry it.
export function trackStarterShown(starter: StarterImpression, position: number): void {
    trackAIChatbotEvent(AIChatbotEvents.STARTER_SHOWN, {
        assistant_type: AIChatbotAssistantType.ASKMEDI,
        question_source: starter.type,
        question: starter.question,
        question_id: starter.id,
        position,
    });
}
